module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26688",
      "conversations-internal-schema": "static-1.12859",
      "head-dlb": "static-1.4994",
      "hs-test-utils": "static-1.7994",
      "hubspot-url-utils": "static-1.4121",
      "HubStyleTokens": "static-2.11448",
      "I18n": "static-7.1617",
      "jasmine-runner": "static-1.6446",
      "quartz": "static-1.7000",
      "react": "static-7.185",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.486",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6119",
      "enviro": "static-4.446",
      "hs-promise-rejection-tracking": "static-1.5566",
      "PortalIdParser": "static-2.397",
      "raven": "static-3.5907",
      "raven-hubspot": "static-1.6214",
      "bend-plugin-trellis-migration": "static-1.3385",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17993",
      "cv-backend-services": "static-1.1552",
      "hub-http": "static-1.6202",
      "immutable": "static-2.79",
      "immutable-less": "static-1.4635",
      "quartz-config": "static-1.778",
      "quartz-core": "static-1.6219",
      "transmute": "static-2.85",
      "HeadJS": "static-2.754",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7892",
      "framer-motion": "static-1.71",
      "hs-test-utils-bend-plugin": "static-1.3105",
      "msw": "static-1.39",
      "react-redux": "static-7.71",
      "redux": "static-4.16",
      "testing-library": "static-1.151",
      "foundations-theming": "static-1.4398",
      "i18n-data": "static-1.220",
      "metrics-js": "static-1.9625",
      "moment-timezone": "static-5.82",
      "react-utils": "static-2.5326",
      "jasmine": "static-4.4307",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.65",
      "styled-components": "static-2.89",
      "UIComponents": "static-3.8394",
      "visitor-ui-component-library-icons": "static-1.5930",
      "bender-build-tools": "static-1.3171",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4630",
      "apollo-stack-hubspot": "static-3.85",
      "classnames": "static-2.10",
      "cssUtils": "static-1.786",
      "customer-data-objects": "static-1.7643",
      "customer-data-ui-utilities": "static-1.9806",
      "data-fetching-client": "static-1.9650",
      "FileManagerCore": "static-1.39053",
      "FileManagerLib": "static-1.39194",
      "foundations-assets": "static-1.4844",
      "graphql": "static-1.81",
      "hs-promise-utils": "static-1.5575",
      "hubspot-apollo-client": "static-1.4857",
      "icons": "static-2.644",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.104",
      "react-virtualized": "static-2.98",
      "rpc-client-utils": "static-1.4631",
      "salesImages": "static-1.524",
      "timezone-utils": "static-2.5224",
      "ui-gdpr-components": "static-1.10326",
      "ts-schema": "static-1.4063",
      "hs-locale-management": "static-1.67",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.136",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.830",
      "hubspotter-http": "static-1.4635",
      "mobile-manifest-mixins": "static-1.529",
      "module-federation": "static-1.22",
      "quartz-auth": "static-1.675",
      "quartz-head": "static-1.665",
      "quartz-i18n": "static-1.675",
      "quartz-routing": "static-1.430",
      "quartz-test": "static-1.675",
      "quartz-tracking": "static-1.379",
      "quick-fetch": "static-1.3898",
      "react-rhumb": "static-1.16647",
      "ui-fonts": "static-1.710",
      "usage-tracker-container": "static-1.7314",
      "usage-tracker-core": "static-1.7174",
      "bend-plugin-foundations-components": "static-1.4161",
      "floating-ui": "static-1.55",
      "foundations-theming-specialty": "static-1.2114",
      "hs-story-utils": "static-1.9407",
      "react-create-root-preference": "static-1.15",
      "tanstack-table": "static-1.54",
      "trellis-assets": "static-1.1812",
      "ui-images": "static-2.1147",
      "bend-plugin-foundations-theming": "static-1.2881",
      "foundations-theming-base": "static-1.3383",
      "stylex": "static-1.32",
      "HubStyle": "static-2.11755",
      "sassPrefix": "static-1.155",
      "inbound-db-properties-service-client": "static-1.3829",
      "property-translator": "static-1.5380",
      "react-dnd-compat": "static-1.4599",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8878",
      "audio-components": "static-1.5882",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29253",
      "file-manager-components": "static-1.23554",
      "FileManagerImages": "static-1.36705",
      "foundations-components-legacy": "static-1.917",
      "immerable": "static-1.4133",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8953",
      "urlinator": "static-1.4516",
      "video-components": "static-1.13194",
      "video-data-lib": "static-1.34849",
      "video-embed": "static-1.35683",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.316",
      "bend-plugin-chirp-manifest": "static-1.41",
      "chirp-fetch": "static-1.1867",
      "hub-http-shared-msw-handlers": "static-1.9907",
      "hubspotter-http-shared-msw-handlers": "static-1.9905",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "usage-tracker-session-replay": "static-1.5010",
      "web-vitals": "static-1.4",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21176",
      "ContentUtils": "static-1.68291",
      "copilot-toolkit": "static-1.11075",
      "customer-data-objects-ui-components": "static-1.13004",
      "sanitize": "static-1.4457",
      "sanitize-text": "static-1.8122",
      "content-assistance-lib": "static-1.7717",
      "usage-tracker": "static-1.7324",
      "ui-addon-iframeable": "static-1.9036",
      "video-components-external": "static-1.11191",
      "unified-auth-core-lib": "static-1.749",
      "content-icons-ui": "static-1.2220",
      "social-insights-client-types": "static-1.22018",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4165",
      "amplitude-session-replay-browser": "static-1.59",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4791",
      "integrations-lib": "static-1.16037",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5539",
      "magpie-types": "static-1.4999",
      "simple-logging-lib": "static-1.3028",
      "atom": "static-1.5051",
      "avatar-components": "static-1.2477",
      "reference-resolvers": "static-1.8149",
      "superstore": "static-1.4743",
      "ui-addon-video-player": "static-1.8683",
      "ui-coaching-tips": "static-1.28484",
      "navigation-messaging": "static-1.7292",
      "content-media-composition-data-lib": "static-1.12178",
      "content-media-compositions": "static-2.16185",
      "idb-keyval": "static-1.43",
      "media-bridge-lib": "static-1.18885",
      "fsm": "static-1.3712",
      "flux-actions": "static-1.333",
      "frontend-preferences-client": "static-1.7908",
      "integrations-error-boundary-lib": "static-1.13452",
      "integrations-tracking-lib": "static-1.5579",
      "laboratory-lib": "static-3.7138",
      "native-integrations-shared-strings": "static-1.7762",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10349",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11131",
      "ui-shepherd-react": "static-3.10137",
      "unified-auth": "static-1.467",
      "reactive-lib": "static-1.702",
      "growth-onboarding-feedback-components": "static-1.6561",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2993",
      "foundations-components-test-utils": "static-1.5375",
      "google-sheets-integration-lib": "static-1.166",
      "microsoft-drive-integration-lib": "static-1.282",
      "react-dlb": "static-1.78",
      "crm-record-cards-service-types": "static-1.3587",
      "framework-data-schema-resolvers": "static-1.6862",
      "location-customization-utils-lib": "static-1.9179",
      "batch-promise": "static-1.1520",
      "conditional-properties-service-client": "static-1.3779",
      "crm-pipelines-api-client-types": "static-1.4124",
      "framework-builder-read-service-client": "static-1.3991",
      "framework-data-schema-quick-fetch": "static-1.6767",
      "inbound-db-meta-service-client": "static-1.3572",
      "multi-currency-client-types": "static-1.3674",
      "persist-promise": "static-1.3677"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26688",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12859",
      "head-dlb": "/head-dlb/static-1.4994",
      "hs-test-utils": "/hs-test-utils/static-1.7994",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4121",
      "HubStyleTokens": "/HubStyleTokens/static-2.11448",
      "I18n": "/I18n/static-7.1617",
      "jasmine-runner": "/jasmine-runner/static-1.6446",
      "quartz": "/quartz/static-1.7000",
      "react": "/react/static-7.185",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.486",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6119",
      "enviro": "/enviro/static-4.446",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
      "PortalIdParser": "/PortalIdParser/static-2.397",
      "raven": "/raven/static-3.5907",
      "raven-hubspot": "/raven-hubspot/static-1.6214",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3385",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17993",
      "cv-backend-services": "/cv-backend-services/static-1.1552",
      "hub-http": "/hub-http/static-1.6202",
      "immutable": "/immutable/static-2.79",
      "immutable-less": "/immutable-less/static-1.4635",
      "quartz-config": "/quartz-config/static-1.778",
      "quartz-core": "/quartz-core/static-1.6219",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.754",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7892",
      "framer-motion": "/framer-motion/static-1.71",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3105",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.71",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.151",
      "foundations-theming": "/foundations-theming/static-1.4398",
      "i18n-data": "/i18n-data/static-1.220",
      "metrics-js": "/metrics-js/static-1.9625",
      "moment-timezone": "/moment-timezone/static-5.82",
      "react-utils": "/react-utils/static-2.5326",
      "jasmine": "/jasmine/static-4.4307",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.65",
      "styled-components": "/styled-components/static-2.89",
      "UIComponents": "/UIComponents/static-3.8394",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5930",
      "bender-build-tools": "/bender-build-tools/static-1.3171",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4630",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.786",
      "customer-data-objects": "/customer-data-objects/static-1.7643",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9806",
      "data-fetching-client": "/data-fetching-client/static-1.9650",
      "FileManagerCore": "/FileManagerCore/static-1.39053",
      "FileManagerLib": "/FileManagerLib/static-1.39194",
      "foundations-assets": "/foundations-assets/static-1.4844",
      "graphql": "/graphql/static-1.81",
      "hs-promise-utils": "/hs-promise-utils/static-1.5575",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4857",
      "icons": "/icons/static-2.644",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.104",
      "react-virtualized": "/react-virtualized/static-2.98",
      "rpc-client-utils": "/rpc-client-utils/static-1.4631",
      "salesImages": "/salesImages/static-1.524",
      "timezone-utils": "/timezone-utils/static-2.5224",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10326",
      "ts-schema": "/ts-schema/static-1.4063",
      "hs-locale-management": "/hs-locale-management/static-1.67",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.136",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.830",
      "hubspotter-http": "/hubspotter-http/static-1.4635",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.529",
      "module-federation": "/module-federation/static-1.22",
      "quartz-auth": "/quartz-auth/static-1.675",
      "quartz-head": "/quartz-head/static-1.665",
      "quartz-i18n": "/quartz-i18n/static-1.675",
      "quartz-routing": "/quartz-routing/static-1.430",
      "quartz-test": "/quartz-test/static-1.675",
      "quartz-tracking": "/quartz-tracking/static-1.379",
      "quick-fetch": "/quick-fetch/static-1.3898",
      "react-rhumb": "/react-rhumb/static-1.16647",
      "ui-fonts": "/ui-fonts/static-1.710",
      "usage-tracker-container": "/usage-tracker-container/static-1.7314",
      "usage-tracker-core": "/usage-tracker-core/static-1.7174",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4161",
      "floating-ui": "/floating-ui/static-1.55",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2114",
      "hs-story-utils": "/hs-story-utils/static-1.9407",
      "react-create-root-preference": "/react-create-root-preference/static-1.15",
      "tanstack-table": "/tanstack-table/static-1.54",
      "trellis-assets": "/trellis-assets/static-1.1812",
      "ui-images": "/ui-images/static-2.1147",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2881",
      "foundations-theming-base": "/foundations-theming-base/static-1.3383",
      "stylex": "/stylex/static-1.32",
      "HubStyle": "/HubStyle/static-2.11755",
      "sassPrefix": "/sassPrefix/static-1.155",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3829",
      "property-translator": "/property-translator/static-1.5380",
      "react-dnd-compat": "/react-dnd-compat/static-1.4599",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8878",
      "audio-components": "/audio-components/static-1.5882",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29253",
      "file-manager-components": "/file-manager-components/static-1.23554",
      "FileManagerImages": "/FileManagerImages/static-1.36705",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.917",
      "immerable": "/immerable/static-1.4133",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8953",
      "urlinator": "/urlinator/static-1.4516",
      "video-components": "/video-components/static-1.13194",
      "video-data-lib": "/video-data-lib/static-1.34849",
      "video-embed": "/video-embed/static-1.35683",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.316",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.41",
      "chirp-fetch": "/chirp-fetch/static-1.1867",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9907",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9905",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5010",
      "web-vitals": "/web-vitals/static-1.4",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21176",
      "ContentUtils": "/ContentUtils/static-1.68291",
      "copilot-toolkit": "/copilot-toolkit/static-1.11075",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13004",
      "sanitize": "/sanitize/static-1.4457",
      "sanitize-text": "/sanitize-text/static-1.8122",
      "content-assistance-lib": "/content-assistance-lib/static-1.7717",
      "usage-tracker": "/usage-tracker/static-1.7324",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9036",
      "video-components-external": "/video-components-external/static-1.11191",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.749",
      "content-icons-ui": "/content-icons-ui/static-1.2220",
      "social-insights-client-types": "/social-insights-client-types/static-1.22018",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4165",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4791",
      "integrations-lib": "/integrations-lib/static-1.16037",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5539",
      "magpie-types": "/magpie-types/static-1.4999",
      "simple-logging-lib": "/simple-logging-lib/static-1.3028",
      "atom": "/atom/static-1.5051",
      "avatar-components": "/avatar-components/static-1.2477",
      "reference-resolvers": "/reference-resolvers/static-1.8149",
      "superstore": "/superstore/static-1.4743",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8683",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28484",
      "navigation-messaging": "/navigation-messaging/static-1.7292",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12178",
      "content-media-compositions": "/content-media-compositions/static-2.16185",
      "idb-keyval": "/idb-keyval/static-1.43",
      "media-bridge-lib": "/media-bridge-lib/static-1.18885",
      "fsm": "/fsm/static-1.3712",
      "flux-actions": "/flux-actions/static-1.333",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7908",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13452",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5579",
      "laboratory-lib": "/laboratory-lib/static-3.7138",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7762",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10349",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11131",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10137",
      "unified-auth": "/unified-auth/static-1.467",
      "reactive-lib": "/reactive-lib/static-1.702",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6561",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2993",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5375",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.166",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.282",
      "react-dlb": "/react-dlb/static-1.78",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6862",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9179",
      "batch-promise": "/batch-promise/static-1.1520",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3779",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4124",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3991",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6767",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3572",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3674",
      "persist-promise": "/persist-promise/static-1.3677"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26688",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};